import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Divider, Grid, Paper, Tab, Tabs, TextField, Typography } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import { ExpandMore } from '@mui/icons-material';
import Global from '../../../customlib/Global';
class ContactDashboardMobile extends Component {
    state = { 
        selectedTab: "PERJAM"
    } 

    handleSelectedTabChange = (event, newValue) => {
        this.setState({selectedTab: newValue});
    };

    render() { 
        return (
            <Box>
                <NavbarMobile title={"Contacts"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props}>
                        <TextField
                            onChange={this.props.handleKeyword}
                            label="Ketik untuk mencari nama atau nomor wa"
                            type="text"
                            className="form-control"
                            id="namacustomer"
                            variant="outlined"
                            onKeyDown={this.props.onKeyDownHandler}
                            onBlur={() => {
                                
                            }}
                            size='small'
                        />
                        <Box sx={{mb: "15px"}}>
                            <small>Field Pencariana : </small>
                            <div className={this.props.getFieldClassName("fromName")} onClick={() => this.props.handleFieldSelectionChanged("fromName")} style={{cursor: "pointer"}}>Nama</div>&nbsp;
                            <div className={this.props.getFieldClassName("from")} onClick={() => this.props.handleFieldSelectionChanged("from")} style={{cursor: "pointer"}}>Nomor</div>&nbsp;
                            <div className={this.props.getFieldClassName("assignToUserName")} onClick={() => this.props.handleFieldSelectionChanged("assignToUserName")} style={{cursor: "pointer"}}>Sales</div>
                        </Box>
                    </Filter>
                    {
                        this.props.state.listMycustomer?.map((contact, index) => {
                            return (
                                <Accordion key={`key-${contact.from}`}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMore />}
                                        aria-controls="panel1-content"
                                        id="panel1-header"
                                    >
                                        <Grid container spacing={1}>
                                            <Grid item xs={12}>
                                                <Typography component="span">{contact.fromName}</Typography>
                                            </Grid>
                                        </Grid>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Paper elevation={2} sx={{mb: "0px", padding: "10px"}}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={3}>
                                                    <Typography component="span">Nomor</Typography>
                                                </Grid>
                                                <Grid item xs={9} textAlign={"right"} sx={{pr: "5px"}}>
                                                    {Global.maskPhoneNumber(contact.from)}
                                                </Grid>
                                            </Grid>
                                            <Divider />
                                            <Grid container spacing={1}>
                                                <Grid item xs={3}>
                                                    <Typography component="span">Owner</Typography>
                                                </Grid>
                                                <Grid item xs={9} textAlign={"right"} sx={{pr: "5px"}}>
                                                    {contact.assignToUserName}
                                                </Grid>
                                            </Grid>
                                            <Divider />
                                            <Grid container spacing={1}>
                                                <Grid item xs={3}>
                                                    <Typography component="span">Leads</Typography>
                                                </Grid>
                                                <Grid item xs={9} textAlign={"right"} sx={{pr: "5px"}}>
                                                    {Global.formatDateTimeToStrDateTime24(contact.created_at)}
                                                </Grid>
                                            </Grid>
                                            <Divider />
                                            <Grid container spacing={1}>
                                                <Grid item xs={3}>
                                                    <Typography component="span">Label</Typography>
                                                </Grid>
                                                <Grid item xs={9} textAlign={"right"} sx={{pr: "5px"}}>
                                                    {contact.label}
                                                </Grid>
                                            </Grid>
                                            <Divider />
                                            <Box textAlign={"center"}>
                                                <Button onClick={() => {this.props.onSelect(Global.generateItemConversation(contact));}}>Open Chat</Button>
                                            </Box>
                                        </Paper>
                                    </AccordionDetails>
                                </Accordion>
                            );
                        })
                    }
                </Box>
            </Box>
        );
    }
}
 
export default ContactDashboardMobile;